import React from "react";

import { hasValue } from "./formatters";

export const ModalDetailsDivider = () => <hr className="my-2 border-gray-200" />;

export const ModalDetailsRow = ({
  label,
  currency,
  value,
  unit,
  strong = false,
}: {
  label: string;
  currency?: string;
  value?: number | string | null;
  unit?: string;
  strong?: boolean;
}) => {
  if (!hasValue(value)) return null;

  return (
    <div
      className={`grid grid-cols-[minmax(0,1fr)_auto_auto_auto] items-center gap-x-3 gap-y-1 py-1.5 ${
        strong ? "font-semibold text-primary500" : "text-gray-700"
      }`}
    >
      <span className="min-w-0 text-left">{label}</span>
      <span className="text-right text-gray-500">{currency}</span>
      <span className="text-right tabular-nums">{value}</span>
      <span className="text-left text-gray-500">{unit}</span>
    </div>
  );
};
